import { DatePicker } from "antd";
import locale from "antd/es/date-picker/locale/pt_BR";
import type { PickerProps } from "antd/lib/date-picker/generatePicker";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import { DATE_FORMAT } from "std/const/date";

type InputCalendarioDateProps = Omit<PickerProps<dayjs.Dayjs>, "value" | "style" | "onOpen" | "onChange" | "format" | "picker" | "defaultValue"> & {
	value?: string | dayjs.Dayjs | Date;
	style?: React.CSSProperties;
	picker?: "date" | "week" | "month" | "quarter" | "year";
	format?: string;
	onOpen?: () => void;
	onChange?: (dateFormated: string | undefined, date: dayjs.Dayjs | null) => void;
	acceptNull?: boolean;
	defaultValue?: string;
};

export function InputCalendarioDate(props: InputCalendarioDateProps) {
	const { value, onChange, onOpen, style, format = DATE_FORMAT, acceptNull = true, defaultValue, ...rest } = props;

	const emptyDate = acceptNull ? null : dayjs();

	return (
		<DatePicker
			locale={locale}
			value={value ? dayjs(value, format) : emptyDate}
			format={format}
			style={{ width: "100%", ...style }}
			onOpenChange={onOpen}
			defaultValue={dayjs(defaultValue, format)}
			onChange={(date) => {
				if (!onChange) {
					return;
				}

				const selectedDate = Array.isArray(date) ? (date[0] ?? null) : date;
				onChange(selectedDate ? selectedDate.format(format) : undefined, selectedDate);
			}}
			{...rest}
		/>
	);
}
